import { Container, IconWrap } from './social-icons.elements';

import {
  IconBrandFacebook,
  IconBrandInstagram,
  IconBrandYoutube,
  IconBrandLinkedin,
  IconBrandWhatsapp,
} from '@tabler/icons-react';

import { companyInfo } from '@/data/company-info.data';

const SocialIcons = ({ dark, small }) => {
  return (
    <Container $dark={dark} $small={small}>
      <a href={companyInfo.facebookUrl} target="_blank" rel="noreferrer noopener">
        <IconWrap $dark={dark}>
          <IconBrandFacebook size={small ? 24 : 36} />
        </IconWrap>
      </a>
      <a href={companyInfo.instagramUrl} target="_blank" rel="noreferrer noopener">
        <IconWrap $dark={dark}>
          <IconBrandInstagram size={small ? 24 : 36} />
        </IconWrap>
      </a>
      <a href={companyInfo.youtubeUrl} target="_blank" rel="noreferrer noopener">
        <IconWrap $dark={dark}>
          <IconBrandYoutube size={small ? 24 : 36} />
        </IconWrap>
      </a>
      <a href={companyInfo.linkedinUrl} target="_blank" rel="noreferrer noopener">
        <IconWrap $dark={dark}>
          <IconBrandLinkedin size={small ? 24 : 36} />
        </IconWrap>
      </a>
      <a href={companyInfo.whatsappUrl} target="_blank" rel="noreferrer noopener">
        <IconWrap
          $dark={dark}
          // $color="whatsapp"
        >
          <IconBrandWhatsapp size={small ? 24 : 36} />
        </IconWrap>
      </a>
    </Container>
  );
};

export { SocialIcons };
